import { render, staticRenderFns } from "./TopPortfolioDividends.vue?vue&type=template&id=fa8929c0&"
import script from "./TopPortfolioDividends.vue?vue&type=script&lang=js&"
export * from "./TopPortfolioDividends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports